'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userPropType = exports.navigationLinkPropType = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navigationLinkPropType = exports.navigationLinkPropType = _propTypes2.default.shape({
  display: _propTypes2.default.string,
  href: _propTypes2.default.string
});

var userPropType = exports.userPropType = {
  firstName: _propTypes2.default.string,
  lastName: _propTypes2.default.string,
  email: _propTypes2.default.string,
  _id: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/NewNavigationBar/navigationPropTypes.js
// module id = 301
// module chunks = 0